import { TFunction } from 'i18next'
import { z } from 'zod'

export const createTopicSchema = (t: TFunction) =>
  z.object({
    receiverOrganizationId: z.string().min(1),
    topicName: z.string().min(1, {
      message: t('required'),
    }),
  })

export const createAnnouncementSchema = (t: TFunction) =>
  z.object({
    announcementText: z.string().min(1, {
      message: t('required'),
    }),
  })

export const createMessageSchema = (t: TFunction) =>
  z.object({
    message: z.string().min(1),
    uploadedFileId: z.string(),
  })
